import React, { useState } from "react";
import { COACH_MARKS_KEY } from "./rfpUtils";

const STEPS = [
  {
    title: "Upload your RFP",
    body: "Start with + New RFP, or switch to Existing RFP to open a past job. Required: Owner SE, Customer (CRM), Country, and PDF.",
  },
  {
    title: "Analysis (RFP Discovery Scope)",
    body: "After upload, RFP Discovery Scope Analysis and Compliance Review start automatically. Use Review RFP Scope inside Analysis to adjust approved technologies and pages, then Regenerate Analysis.",
  },
  {
    title: "Compliance Review",
    body: "Use Compliance Review to fix product or class tags, add SE comments, run compliance, and export Excel.",
  },
];

export default function RfpCoachMarks() {
  const [step, setStep] = useState(() => {
    try {
      return localStorage.getItem(COACH_MARKS_KEY) ? -1 : 0;
    } catch {
      return 0;
    }
  });

  if (step < 0) return null;

  const finish = () => {
    try {
      localStorage.setItem(COACH_MARKS_KEY, "1");
    } catch {
      /* ignore */
    }
    setStep(-1);
  };

  const cur = STEPS[step];
  if (!cur) {
    finish();
    return null;
  }

  return (
    <div className="fixed inset-0 z-[95] flex items-end justify-center bg-black/50 p-4 sm:items-center">
      <div className="w-full max-w-lg rounded-2xl border border-slate-200 bg-white p-6 shadow-2xl dark:border-slate-700 dark:bg-slate-900">
        <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700 dark:text-emerald-300">
          Welcome · Step {step + 1} of {STEPS.length}
        </p>
        <h3 className="mt-2 text-xl font-semibold">{cur.title}</h3>
        <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">{cur.body}</p>
        <div className="mt-6 flex justify-between gap-2">
          <button type="button" className="text-sm text-slate-500 hover:underline" onClick={finish}>
            Skip tour
          </button>
          <div className="flex gap-2">
            {step > 0 && (
              <button
                type="button"
                className="rounded-lg border px-3 py-1.5 text-sm dark:border-slate-600"
                onClick={() => setStep((s) => s - 1)}
              >
                Back
              </button>
            )}
            <button
              type="button"
              className="rounded-lg bg-emerald-700 px-4 py-1.5 text-sm font-medium text-white"
              onClick={() => {
                if (step >= STEPS.length - 1) finish();
                else setStep((s) => s + 1);
              }}
            >
              {step >= STEPS.length - 1 ? "Get started" : "Next"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
